<template>
    <div class="container goods-form-2">
        <div class="common-header-wrap">
            <mt-header title="محرر الجرد" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div v-for="(spvalue_key,k) in specArray.spvalue_key" :key="k">
            <div class="label">{{spec[spvalue_key].label}}</div>
            <mt-field label="مخزون السلع" v-model="spec[spvalue_key].goods_storage"></mt-field>
        </div>
        <mt-button class="menu-btn" type="primary" size="large" @click="submit">حفظ</mt-button>
    </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { getCommonData, goodsEdit, goodsSave } from '../../../api/chainManage'
export default {
  data () {
    return {
      ifLoad: 0,
      commonid: this.$route.query.commonid,
      class_id: this.$route.query.class_id,
      goods: { goods_state: true },
      showSpecName: false,
      showSpecValue: false,
      showSpecAdd: false,
      ifSpec: false,
      mulSpec: false,
      sp_val: {},
      sp_name: {},
      sp_option: {},
      spec_list: false,
      spec_json: false,
      sp_id: 0,
      spec_add_value: '',
      specArray: false,
      spec: {},
      spec_checked: false
    }
  },

  created () {
    getCommonData(this.class_id).then(res => {
      var spec_list = res.result.spec_list
      var sp_option = {}
      if (spec_list && Object.keys(spec_list).length) {
        this.mulSpec = true
        for (var k in spec_list) {
          var val = spec_list[k]
          sp_option[k] = []
          this.sp_val[k] = []
          if (typeof (this.sp_name[k]) === 'undefined') {
            this.sp_name[k] = val.sp_name
          }
          for (var j in val.value) {
            sp_option[k].push({
              label: val.value[j].spvalue_name,
              value: val.value[j].spvalue_id
            })
          }
        }
      }
      this.spec_json = res.result.spec_json
      this.sp_option = sp_option
      this.spec_list = spec_list

      this.ifLoad++
    }).catch(error => {
      Toast(error.message)
    })
    if (this.commonid) {
      goodsEdit(this.commonid).then(res => {
        var spec_checked = res.result.spec_checked
        var goods = res.result.goods

        this.goods = goods

        if (goods.spec_name) {
          for (var k in goods.spec_name) {
            this.sp_name[k] = goods.spec_name[k]
          }
        }

        var sp_value = res.result.sp_value
        for (var i in sp_value) {
          this.spec[i] = {
            goods_id: sp_value[i]['id'],
            label: sp_value[i]['label'],
            color: sp_value[i]['color'],
            sp_value: sp_value[i]['sp_value'],
            goods_marketprice: sp_value[i]['marketprice'],
            goods_price: sp_value[i]['price'],
            goods_storage_alarm: sp_value[i]['alarm'],
            goods_serial: sp_value[i]['sku'],
            goods_storage: sp_value[i]['stock'],
            goods_weight: sp_value[i]['goods_weight']
          }
        }

        this.spec_checked = spec_checked

        this.ifLoad++
      }).catch(error => {
        Toast(error.message)
      })
    }
  },
  watch: {
    ifLoad: function () {
      if (this.spec_checked && Object.keys(this.spec_checked).length && this.spec_json && Object.keys(this.spec_json).length) {
        this.ifSpec = true
        var spvalue_ids = Object.keys(this.spec_checked)
        for (var i in this.spec_json) {
          var temp = Object.keys(this.spec_json[i])
          var arr = temp.filter(function (v) {
            return spvalue_ids.indexOf(v) !== -1 // 利用filter方法来遍历是否有相同的元素
          })
          if (arr.length) {
            this.sp_val[i] = arr
          }
        }
        this.getSpecArray()
      }
      this.$forceUpdate()
    }
  },
  methods: {
    submit () {
      goodsSave({ spec: this.spec }).then(res => {
        Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    getSpecArray () {
      let sp_val = this.sp_val

      this.specArray = this.doExchange(sp_val)
      this.$forceUpdate
    },
    doExchange (arr) {
      var len = Object.keys(arr).length
      // 当数组大于等于2个的时候
      if (len >= 2 || typeof (arr[0]) === 'undefined') {
        var j = 0
        var myArr = []
        // 将新组合的数组并到原数组中
        var newArr = {}
        for (var i in arr) {
          if (myArr.length > 1) {
            if (arr[i].length) {
              newArr[i] = arr[i]
            }
          } else {
            if (i == 0 || arr[i].length) {
              myArr.push({ sp_id: i, spvalue_id: arr[i] })
            }
          }
          j++
        }

        if (myArr.length > 0) {
          var temp
          if (typeof (arr[0]) === 'undefined') {
            temp = { spvalue_id: [], spvalue_name: [] }
            for (var i in myArr[0].spvalue_id) {
              temp.spvalue_id[i] = [myArr[0].spvalue_id[i]]
              temp.spvalue_name[i] = [this.spec_json[myArr[0].sp_id][myArr[0].spvalue_id[i]].spvalue_name]
            }
          } else {
            temp = arr[0]
          }

          if (myArr.length > 1) {
            newArr[0] = { spvalue_id: [], spvalue_name: [] }
            var index = 0
            for (var i in temp.spvalue_id) {
              for (var j in myArr[1].spvalue_id) {
                newArr[0].spvalue_id[index] = temp.spvalue_id[i].concat([myArr[1].spvalue_id[j]])
                newArr[0].spvalue_name[index] = temp.spvalue_name[i].concat([this.spec_json[myArr[1].sp_id][myArr[1].spvalue_id[j]].spvalue_name])

                index++
              }
            }
          } else {
            newArr[0] = temp
          }
        } else {
          newArr[0] = []
        }

        // 执行回调
        return this.doExchange(newArr)
      } else {
        arr[0]['spvalue_key'] = []
        for (var i in arr[0].spvalue_id) {
          let color = null
          var spvalue_id_list = arr[0].spvalue_id[i]
          if (this.spec_list[1]) {
            for (var j in this.spec_list[1].value) {
              if (spvalue_id_list.indexOf(this.spec_list[1].value[j].spvalue_id) > -1) {
                color = this.spec_list[1].value[j].spvalue_id
              }
            }
          }
          var spvalue_name = arr[0].spvalue_name[i]
          var spvalue_id = arr[0].spvalue_id[i]
          var sp_value = {}
          for (var k in spvalue_name) {
            sp_value[spvalue_id[k]] = spvalue_name[k]
          }
          var spvalue_id_str = spvalue_id.sort(function (a, b) { return a - b }).join('')
          arr[0]['spvalue_key'].push(spvalue_id_str)
          if (typeof (this.spec[spvalue_id_str]) === 'undefined') {
            this.spec[spvalue_id_str] = {
              goods_id: 0,
              label: arr[0].spvalue_name[i].join('|'),
              color: color,
              sp_value: sp_value,
              goods_marketprice: this.goods.goods_marketprice,
              goods_price: this.goods.goods_price,
              goods_storage_alarm: this.goods.goods_storage_alarm,
              goods_serial: this.goods.goods_serial,
              goods_storage: this.goods.goods_storage,
              goods_weight: this.goods.goods_weight
            }
          }
        }

        return arr[0]
      }
    }
  }
}
</script>

<style scoped lang="scss">
    .container{
        background: #fff;
        .label{
            padding:.5rem;
            font-size: .7rem;
            background: #eee;
        }
    }
</style>
